export class FolderModel {
  constructor(public id: string,
              public clientID: string,
              public createdAt: string,
              public invoices: any,
              public name: string,
              public updatedAt: string) {
  }
}
